import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'

export type DeleteTimeLogModalProps = {
  open: boolean
  handleClose: VoidFunction
  handleDelete: VoidFunction
  isLoading: boolean
  employeeName: string
}

export function DeleteTimeLogModal({
  open,
  handleClose,
  handleDelete,
  isLoading,
  employeeName
}: Readonly<DeleteTimeLogModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose} data-testid="delete-time-log-modal">
      <ActionModal
        title={t('dialog.volunteering.deleteTimeLog.title')}
        primaryButtonText={t('button.yesDelete')}
        secondaryButtonText={t('button.keepTimeLog')}
        handleClose={handleClose}
        handleSubmit={handleDelete}
        loading={isLoading}
      >
        <Trans
          i18nKey="dialog.volunteering.deleteTimeLog.description"
          components={{ b: <b /> }}
          values={{ employeeName }}
        />
      </ActionModal>
    </Modal>
  )
}
